import { createAnalyticsInterface, createReportingInterface, createParmInterface } from "@gwn/guac-lib";
import { createSmartAuthInterface } from "@gwn/guac-lib/dist/interfaces/smart";

export const getStandaloneInterfaces = () => {
  const measurementId = process.env.VUE_APP_GA_MEASUREMENT_ID;

  return {
    analyticsInterface: createAnalyticsInterface({
      applicationName: "@getwell/nurse-console-standalone",
      serviceName: measurementId ? "googleAnalytics" : "disabled",
      trackingId: measurementId,
    }),
  };
};

export const getReportingInterface = () => {
  const dsn = process.env.VUE_APP_SENTRY_DSN;
  const env = process.env.VUE_APP_ENVIRONMENT;
  return createReportingInterface({
    serviceName: dsn && env !== "local" ? "sentry" : "disabled",
    dsn: dsn,
    version: process.env.VUE_APP_VERSION,
    environment: env,
  });
};

export const getParmInterface = (isSmartEnv: boolean) => {
  // console.log("getParmInterface");
  const url = process.env.VUE_APP_GUAC_PARM_URL;
  const autoPath = process.env.VUE_APP_GUAC_PARM_AUTO_PATH;
  const permPath = process.env.VUE_APP_GUAC_PARM_PERMISSIONS_PATH;
  // console.log("getParmInterface url: " + url);
  const parmInterface = createParmInterface(
    {
      url: url,
      autoPath: autoPath,
      permPath: permPath,
    },
    isSmartEnv
  );
  return parmInterface.parmAutoProvision();
};

export const getSmartAuthInterface = (sessionId: string) => {
  // console.log("getSmartAuthInterface");
  return createSmartAuthInterface(sessionId);
};
